import { UserTypes } from "."

export const selectedUserAction = (id: string) => async (dispatch: any) => {
	dispatch({
		type: UserTypes.SELECT_USER,
		payload: id,
	})
}
